
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/flights",
      function () {
        return require("private-next-pages/[locale]/flights.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/flights"])
      });
    }
  